import React from 'react';
import LandingPage from '../components/LandingPage';

function HomePage() {
  return <LandingPage />;
}

export default HomePage;
